import Modal from "/WebInterface/new-ui/modules/modal.js";
import Tooltip from "/WebInterface/new-ui/modules/tooltip/tooltip.js";
import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import store from "/WebInterface/new-ui/manage-shares/js/reducer.js";
import {
  shareDetailsLayoutTemplate,
  shareDetailsDataGridTemplate,
  deleteButtonTemplate,
  editButtonTemplate,
} from "/WebInterface/new-ui/manage-shares/modules/modals/share-details/template.js";
import { initEditModal } from "/WebInterface/new-ui/manage-shares/modules/modals/edit-details/edit-details.js";
import { deleteManageShareItems } from "/WebInterface/new-ui/manage-shares/utils/api.js";
import { initMatchingModal } from "/WebInterface/new-ui/manage-shares/modules/modals/select-matching-accounts/select-matching-accounts.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import { translateComponent } from "/WebInterface/new-ui/modules/localizations/localizations.js";

// To invoke parent methods
function invoke(method, params) {
  if (parent.window[method]) {
    return parent.window[method].apply(this, params);
  }
}

export const initShareDetails = (index) => {
  let currentIndex = index;
  const details = store.shareList[currentIndex];
  console.log(details, index, store.shareList);

  const dialog = new Modal({
    title: "shareDetails",
    body: shareDetailsLayoutTemplate({}),
    uniqueId: "manage-shares-share-details-modal",
    minWidth: "950px",
    minHeight: "650px",
    movable: true,
    hasResizeOption: true,
    translateComponentMethod: translateComponent,
  });

  const tooltip = new Tooltip();

  _$(dialog.root)
    .find("[data-tooltip]")
    .sel()
    .forEach((button) => {
      tooltip.addTooltip({
        element: button,
        tooltipText: t(_$(button).attr("data-tooltip")),
      });
    });

  const updateDialogDetails = () => {
    const details = store.shareList[currentIndex];
    const isInternalShare = details?.usernameShare === "true";

    const hideShareLinkAndPassword = invoke("getUserCustomizationValue", [
      "manageShare_DetailsHideLinkPass",
    ]);

    const leftSideDetails = [
      {
        title: t("link"),
        value: utils.textEncode(details?.web_link),
        i18n_key: "link",
        field_name: "web_link",
        hide: hideShareLinkAndPassword,
      },
      {
        title: t("from"),
        value: utils.textEncode(details?.emailFrom),
        i18n_key: "from",
        field_name: "emailFrom",
      },
      {
        title: t("to"),
        value: utils.textEncode(details?.emailTo),
        i18n_key: "to",
        field_name: "emailTo",
      },
      {
        title: t("cc"),
        value: utils.textEncode(details?.emailCc),
        i18n_key: "cc",
        field_name: "emailCc",
      },
      {
        title: t("bcc"),
        value: utils.textEncode(details?.emailBcc),
        i18n_key: "bcc",
        field_name: "emailBcc",
      },
      {
        title: t("replyTo"),
        value: utils.textEncode(details?.emailReplyTo),
        i18n_key: "replyTo",
        field_name: "emailReplyTo",
      },
      {
        title: t("body"),
        value: utils.textEncode(details?.emailBody),
        i18n_key: "body",
        field_name: "emailBody",
      },
      {
        title: t("subject"),
        value: utils.textEncode(details?.emailSubject),
        i18n_key: "subject",
        field_name: "emailSubject",
      },
    ];

    const rightSideDetails = [
      {
        title: t("created"),
        value: utils.textEncode(details?.created),
        i18n_key: "created",
        field_name: "created",
        internalColumn: true,
        internalColumnOrder: 2,
      },
      {
        title: t("expires"),
        value: utils.textEncode(details?.expire),
        i18n_key: "expires",
        field_name: "expire",
        internalColumn: true,
        internalColumnOrder: 3,
      },
      {
        title: t("remainingUses"),
        value: utils.textEncode(details?.login_allowance_formatted),
        i18n_key: "remainingUses",
        field_name: "login_allowance_formatted",
      },
      {
        title: t("Download"),
        value: utils.textEncode(details?.downloads),
        i18n_key: "Download",
        field_name: "downloads",
        internalColumn: true,
        internalColumnOrder: 4,
      },
      {
        title: t("shareType"),
        value: utils.textEncode(details?.publishType),
        i18n_key: "shareType",
        field_name: "publishType",
        internalColumn: true,
        internalColumnOrder: 1,
      },
      {
        title: t("username"),
        value: utils.textEncode(details?.username),
        i18n_key: "username",
        field_name: "username",
        internalColumn: true,
        internalColumnOrder: 0,
      },
      {
        title: t("password"),
        value: utils.textEncode(details?.password),
        i18n_key: "password",
        field_name: "password",
        hide: hideShareLinkAndPassword,
      },
      {
        title: t("attachedInEmail"),
        value: utils.textEncode(details?.attach === "false" ? "No" : "Yes"),
        i18n_key: "attachedInEmail",
        field_name: "attach",
      },
      {
        title: t("uploadAllowed"),
        value: utils.textEncode(
          isInternalShare
            ? details?.allowUploads
            : details?.allowUploads === "false"
            ? "No"
            : "Yes"
        ),
        i18n_key: "uploadAllowed",
        field_name: "allowUploads",
        internalColumn: true,
        internalColumnOrder: 5,
      },
      {
        title: t("comments"),
        value: details?.comments_formatted,
        i18n_key: "comments",
        field_name: "comments_formatted",
        internalColumn: true,
        internalColumnOrder: 6,
      },
      {
        title: t("paths"),
        value: utils.textEncode(details?.paths_encoded),
        i18n_key: "paths",
        field_name: "paths_encoded",
        internalColumn: true,
        internalColumnOrder: 7,
      },
    ];

    if (isInternalShare) {
      _$("#share-details-data .share-details-column-wrapper").addClass(
        "share-type-internal"
      );
    } else {
      _$("#share-details-data .share-details-column-wrapper").removeClass(
        "share-type-internal"
      );
    }

    _$("#share-details-data .share-details-data-left").html("");

    leftSideDetails.forEach((detail) => {
      const { title, value, i18n_key, field_name, internalColumn, hide } =
        detail;

      console.log(hide);

      if (hide) {
        return;
      }

      if (!internalColumn && isInternalShare) {
        return;
      }

      const wrapper = _$("<div>");
      wrapper.html(
        shareDetailsDataGridTemplate({
          title,
          value: typeof value === "string" ? value : "-",
          i18n_key: i18n_key || title?.toLocaleLowerCase(),
        })
      );
      _$("#share-details-data .share-details-data-left").append(wrapper.el());

      const matchingbutton = wrapper.find(".search-button");
      matchingbutton.on("click", () => {
        initMatchingModal(title, value, field_name, dialog);
      });
    });

    _$("#share-details-data .share-details-data-right").html("");

    rightSideDetails.forEach((detail) => {
      const {
        title,
        value,
        i18n_key,
        field_name,
        internalColumn,
        internalColumnOrder,
        hide,
      } = detail;

      if (hide) {
        return;
      }

      if (!internalColumn && isInternalShare) {
        return;
      }

      const wrapper = _$("<div>");
      wrapper.html(
        shareDetailsDataGridTemplate({
          title,
          value: typeof value === "string" ? value : "-",
          i18n_key: i18n_key || title?.toLocaleLowerCase(),
        })
      );
      _$("#share-details-data .share-details-data-right").append(wrapper.el());

      if (isInternalShare) {
        wrapper.css("order", internalColumnOrder);
      }

      const matchingbutton = wrapper.find(".search-button");
      matchingbutton.on("click", () => {
        initMatchingModal(title, value, field_name, dialog);
      });
    });

    _$("#shareDetailsActions").html("");

    if (!isInternalShare) {
      _$("#shareDetailsActions")
        .el()
        .insertAdjacentHTML(
          "beforeend",
          editButtonTemplate({ editText: t("edit") })
        );

      const editbutton = _$(dialog.root).find("#manageShareDetailsEdit");
      editbutton.on("click", () => initEditModal(currentIndex, dialog));
    }

    _$("#shareDetailsActions")
      .el()
      .insertAdjacentHTML(
        "beforeend",
        deleteButtonTemplate({ deleteText: t("Delete") })
      );

    const deletebutton = _$(dialog.root).find("#manageShareDetailsDelete");
    deletebutton.on("click", async () => {
      const resp = await Confirm({
        title: `<span data-i18n-key='confirm'>${t("confirm")}</span>`,

        body: `<span data-i18n-key="areYouSureYouWantToDeleteSelectedAccounts" data-i18n-opt='{"count":"1"}'>${t(
          "areYouSureYouWantToDeleteSelectedAccounts",
          { count: 1 }
        )}</span>`,

        confirm: `<span data-i18n-key='ok'>${t("ok")}</span>`,
        cancel: `<span data-i18n-key='cancel'>${t("cancel")}</span>`,
        closable: false,
      });
      if (resp) {
        try {
          let username = details?.username;
          const shareUsername = details?.usernameShare === "true";
          if (shareUsername) {
            const paths = details?.paths;
            username += `:${paths}`;
          }
          await deleteManageShareItems({ tempUsername: `${username};` });
          store.dispatch("refreshShareListing");
          dialog?.hide(true);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const prevButton = _$(dialog.root).find(".manage-share-details-prev-btn");
  prevButton.on("click", () => {
    if (currentIndex === 0) return;
    currentIndex--;
    updateDialogDetails();
  });

  const nextButton = _$(dialog.root).find(".manage-share-details-next-btn");
  nextButton.on("click", () => {
    if (currentIndex + 1 === store.shareList.length) return;
    currentIndex++;
    updateDialogDetails();
  });

  updateDialogDetails();
};
